export const dmType = {
  PROSPECT: 'PROSPECT',
  ITA: 'ITA',
  PL_PRE_APPROVAL: 'PL_PRE_APPROVAL',
};

